export default "__VITE_ASSET__8f4173b0__"